import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(({
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[800]
	},
	dateInput: {
		paddingLeft: "0px",
		marginRight: "0px",
		height: "56px"
	},
	searchButton: {
		height: "55px"
	}
}))

export default useStyles
